import React from 'react'

const Brand = () => {
    return (
        <div className=" d-flex justify-content-start branding">
            <h3 className="p-2 fw-bold">Trello_MockUp</h3>
        </div>
    )
}

export default Brand
